import { Form, Grid, Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import HomesGlobeSmallIcon from "@/assets/brand/HomesGlobeSmallIcon";
import Button from "@/common/atoms/Button";
import { ErrorAlert } from "@/common";
import { resetPasswordRequest } from "../duck/auth";
import AuthHeading from "../common/AuthHeading";
import BrnadInfoAuth from "../common/BrandInfoAuth";
import "./ResetPasswordModal.scss";
import { PASSWORD_REGEX } from "@/utils";

const ResetPasswordComponent = ({ token }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const isMobile = !screens.lg;

  const { resetPasswordLoading, error } = useSelector(
    (state) => state.auth,
    shallowEqual
  );

  const onFinish = (values) => {
    const { password } = values;
    dispatch(resetPasswordRequest({ password, token }));
  };

  return (
    <div className="flex gap-1 relative sign-up-modal">
      <div className="bg-white rounded-lg mt-[40px] p-8 flex-[2] relative sign-up-modal overflow-hidden flex flex-col justify-evenly">
        <HomesGlobeSmallIcon />
        <AuthHeading
          title={t("changePassword.resetPassword")}
          subTitle={t("changePassword.instruction")}
        />
        {/* FORM */}
        {error && <ErrorAlert error={error} />}
        <Form
          form={form}
          name="forgotPassword"
          onFinish={onFinish}
          layout="vertical">
          <Form.Item
            name="password"
            label={
              <span className="text-gray-700">{t("common.password")}</span>
            }
            rules={[
              { required: true, message: t("common.passwordRequired") },
              {
                pattern: PASSWORD_REGEX,
                message: t("changePassword.passwordRequirements")
              }
            ]}>
            <Input.Password
              placeholder={t("common.enterPassword")}
              iconRender={(visible) =>
                visible ? (
                  <EyeTwoTone twoToneColor="#7B9E7E" />
                ) : (
                  <EyeInvisibleOutlined />
                )
              }
              className="rounded-md h-12 flex items-center justify-center "
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label={
              <span className="text-gray-700">
                {t("common.confirmPassword")}
              </span>
            }
            rules={[
              { required: true, message: t("common.confirmPasswordRequired") },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(t("common.passwordsDoNotMatch"))
                  );
                }
              })
            ]}>
            <Input.Password
              placeholder="Re-Enter Password"
              iconRender={(visible) =>
                visible ? (
                  <EyeTwoTone twoToneColor="#7B9E7E" />
                ) : (
                  <EyeInvisibleOutlined />
                )
              }
              className="rounded-md h-12 flex items-center justify-center "
            />
          </Form.Item>

          <Form.Item>
            <Button
              loading={resetPasswordLoading}
              htmlType="submit"
              className="w-full my-4 p-4 h-[37px]">
              {t("common.submit")}
            </Button>
          </Form.Item>
        </Form>
        {/* FORM */}
      </div>
      {!isMobile && (
        <div className="flex-[1.5]  h-auto">
          <BrnadInfoAuth
            title={t("brandInfoAuth.title")}
            subTitle1={t("brandInfoAuth.subTitle1")}
            subTitle2={t("brandInfoAuth.subTitle2")}
          />
        </div>
      )}
    </div>
  );
};

export default ResetPasswordComponent;
